module.exports = __webpack_public_path__ + "static/backDropImage-c4fae59556e81fe2d5101cb1cecbeb1e.jpg";